import qs from 'qs';
import config from '@/config';
import { CoreApi } from './core.api';
import { toGymTime, toDateFilter } from './gym-time';

export { toGymTime } from './gym-time';

const LESSONS_PAGE_SIZE = 100;

export const coreApi = new CoreApi({
    baseURL: config.CORE_API,
    // The backend parses filter objects from bracket notation
    // (e.g. date[gte]=...), which axios' default serializer cannot express.
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
});

export async function getGyms() {
    const { data } = await coreApi.gyms.gymControllerListGyms();
    return data;
}

export async function getGroupLessons() {
    const {
        data
    } = await coreApi.groupLessons.groupLessonControllerGetGroupLessons();
    return data.data;
}

export async function getLessons({ gymId, from, until }) {
    const lessons = [];
    let offset = 0;
    let hasNextPage = true;

    while (hasNextPage) {
        const { data } = await coreApi.lessons.lessonControllerPaginateLessons({
            take: LESSONS_PAGE_SIZE,
            offset,
            gymId: { equals: gymId },
            date: { gte: toDateFilter(from), lt: toDateFilter(until) }
        });
        lessons.push(
            ...data.data.map(lesson => ({
                ...lesson,
                date: toGymTime(lesson.date)
            }))
        );
        offset += LESSONS_PAGE_SIZE;
        hasNextPage = data.meta.hasNextPage;
    }

    return lessons;
}
